<template>
<div >
    <el-row id="course-apply" class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                   <signInManageEdit></signInManageEdit>
                </div>
            </div>

        </el-col>
    </el-row>
</div>
</template>


<script>
import navigator from "../../components/navigator";
import signInManageEdit from "../../components/signInManage/signInMangeEdit";

export default {
    components: {
        navigator,
        signInManageEdit
    },
    data() {
        return {
            param: {}
        }
    },
    created() {
        this.param = this.$route.query;
    },
    methods: {
        back() {
            this.$router.back(-1);
        },
        cellStyle(cell) {
            let cellClass = "";
            if ((cell.rowIndex + 1) % 2 == 1) {
                cellClass = "el-table-cell-single";
            } else {
                cellClass = "el-table-cell-double";
            }
            return cellClass;
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/signInManageEdit.vue